<template>
	<div class="menuBody">
		<div class="menuTool" style="width:100%;">
			<el-row :gutter="10">
				<div class="search-title">
					仪表手抄列表
				</div>
				<div class="search-input-item">
					<el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
				</div>
				<div class="search-input-item">
					<el-input size="small" v-model="query.roomName" placeholder="请输入房间号" clearable></el-input>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.meterType" placeholder="请选择仪表类型" clearable>
						<el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.orderStatus" placeholder="请选择生成状态" clearable>
						<el-option v-for="item in orderStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.payStatus" placeholder="请选择销帐状态" clearable>
						<el-option v-for="item in payStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="search-input-item">
					<el-date-picker
						v-model="query.dataRange"
						type="daterange"
						align="right"
						size="small"
						style="width: 410px"
						value-format="yyyyMM"
						unlink-panels
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:picker-options="pickerOptions"
					>
					</el-date-picker>
				</div>
				<div class="search-button-tools">
					<el-button size="small" type="primary" :loading="tableLoading" v-Jurisdiction="'hydropower.web.basic.handwork.listPage'" @click="doSearch">查询</el-button>
					<el-button size="small" type="primary" v-debounce v-Jurisdiction="'hydropower.web.basic.handwork.generateBill'" :disabled="disableMulAction" @click="doGenerateBill">生成账单</el-button>
					<el-button size="small" type="primary" v-debounce v-Jurisdiction="'hydropower.web.basic.handwork.export'" @click="doExport">导出</el-button>
					<el-button size="small" type="danger" v-debounce v-Jurisdiction="'hydropower.web.basic.handwork.delete'" :disabled="disableMulAction" @click="doDelete">删除</el-button>
				</div>
				<el-table :data="tableData" @selection-change="handleSelectionChange" row-key="id" border :stripe="true" v-loading="tableLoading">
					<el-table-column width="55" fixed="left" type="selection"></el-table-column>
					<el-table-column width="200" prop="payMeterNo" label="表号"></el-table-column>
					<el-table-column width="250" prop="actualNo" label="实际表号"></el-table-column>
					<el-table-column width="100" prop="meterType" label="类型"></el-table-column>
					<el-table-column width="100" prop="roomName" label="房间"></el-table-column>

					<el-table-column width="120" prop="accrualDate" label="应收日期"></el-table-column>
					<el-table-column width="120" prop="beforeNum" label="上期读数" align="right"></el-table-column>
					<el-table-column width="120" prop="nowNum" label="本期读数" align="right"></el-table-column>
					<el-table-column width="120" prop="beilv" label="倍率"></el-table-column>
					<el-table-column width="120" prop="price" label="单价（元）" align="right"></el-table-column>
					<el-table-column width="100" prop="loss" label="线损"></el-table-column>
					<el-table-column width="100" prop="useNum" label="用量" align="right"></el-table-column>
					<el-table-column width="120" prop="money" label="金额（元）" align="right"></el-table-column>
					<el-table-column width="100" prop="payMoney" label="已缴" align="right"></el-table-column>
					<el-table-column width="180" prop="chargeStartDate" label="计费开始日期"></el-table-column>
					<el-table-column width="180" prop="chargeEndDate" label="计费结束日期"></el-table-column>
					<el-table-column width="180" prop="readDate" label="抄表日期"></el-table-column>
					<el-table-column width="180" prop="createDate" label="录入日期"></el-table-column>
					<el-table-column width="150" prop="createByStr" label="录入人"></el-table-column>
					<el-table-column width="100" prop="orderStatusStr" label="生成状态">
						<template slot-scope="scope">
							<span :class="isAddRed(scope.row.orderStatus)">{{ scope.row.orderStatusStr }}</span>
						</template>
					</el-table-column>
					<el-table-column width="100" prop="payStatusStr" label="销帐状态"></el-table-column>
					<el-table-column prop="remarks" label="备注"></el-table-column>
				</el-table>
				<simple-pagination @search="doSearch" />
			</el-row>
		</div>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import { orderStatus, payStatus, meterType } from "@/dict/meterDict";
import mixin from "@/mixin/index";
import { assign, pick } from "lodash";
import { get, post, del, put, download, alertMultiMessage } from "@/assets/common/request";
export default {
	name: "MeterHandwork",
	mixins: [mixin],
	props: {
		parentData: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
	data() {
		return {
			orderStatus,
			payStatus,
			meterType,
			queryListUrl: "/meter/web/handwork/listPage",
		};
	},
	methods: {
		doSearch() {
			this.getList();
		},
		doExport() {
			const title = "手抄数据";
			const url = "meter/web/handwork/export";
			this._export(title, url);
		},
		doGenerateBill() {
			this.handleSelectionCall((ids) => {
				const url = "meter/web/handwork/generateBill";
				post(url, { ids: ids }).then((data) => {
					alertMultiMessage(data);
				});
			});
		},
		doDelete() {
			this._del((ids) => {
				const url = `meter/web/handwork/delete/${ids}`;
				del(url).then(() => {
					this.doSearch();
				});
			});
		},
		selectNode(data) {
			this.query = assign(this.query, data);
			this.doSearch();
		},
		isAddRed(val) {
			return val < 0 ? "red" : "";
		},
	},
	watch: {
		parentData(val) {
			this.query = assign(this.query, this.parentData);
			this.doSearch();
		},
	},
	mounted() {
		this.query = assign(this.query, this.parentData);
		this.doSearch();
	},
};
</script>
